import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarAssistenciasTecnicasProduto(api, parametros) {    
    parametros.operacao = 'buscarAssistenciasTecnicasProduto'
    let retorno = {};
    
    await api.santriGET('/rest/produto', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })
    return retorno;
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/RProduto/RProdutoBuscarAssistenciasTecnicasProduto.js